<template>
   <div class="update-mcq-element container-fluid"> 
        <div class="row margin-bottom-2Perc" v-for="currentOption in totalOptions" :key="currentOption"> 
          <div class="col-md-1 col-lg-1 margin-top-0Point7Perc" v-if="getSelectedMCQTypeValue === 0">
            <input type="radio" value="true" v-model="tempOptionArr[currentOption - 1].IsSelected" @click="selectedSingleChoiceOption($event,currentOption)">
          </div>
          <div class="col-md-1 col-lg-1 margin-top-0Point7Perc" v-if="getSelectedMCQTypeValue === 1">
            <input type="checkbox" value="true" v-model="tempOptionArr[currentOption - 1].IsSelected">
          </div>
          <div class="col-md-1 col-lg-1 font-weight-bold font-color-blue font-size-21px margin-top-0Point5Perc">
            {{tempOptionArr[currentOption - 1].OptionNo}}
            <!-- {{alphabetArr[currentOption-1]}} -->
          </div>
          <div class="col-md-2 col-lg-2 background-color-grey">
            <div class="row course-image-box-border">
              <div class="" v-show="tempOptionArr[currentOption - 1].IsImageSelected">
                <div class="loader" v-if="tempOptionArr[currentOption - 1].showSpinner"></div>
                <div class="container padding-left-right-0px course-image-height img-responsive zoom">
                  <img v-bind:id="'mcqImg_' + tempOptionArr[currentOption - 1].OptionId" class="course-image-height img-responsive horizontal-center-align">
                  <div class="middle cursor-pointer" v-if="!tempOptionArr[currentOption - 1].showSpinner">
                  <div class="text vertical-align" v-on:click="updateIsMcqImageSelectedFlag($event, tempOptionArr[currentOption - 1].OptionId, currentOption - 1, false)">Remove</div>
                  </div>
                </div>
              </div>  
              <div class="col-md-12 col-lg-12 padding-top-13Perc" v-show="!tempOptionArr[currentOption - 1].IsImageSelected">
                <div class="loader" v-if="tempOptionArr[currentOption - 1].showSpinner"></div>
                <img src= "../assets/images/upload.svg" v-on:click="openFileExplorerWindow($event, tempOptionArr[currentOption - 1].OptionId, currentOption - 1)"  class="cursor-pointer img-responsive upload-img-width-height horizontal-center-align" alt="IPL-Logo" :class="{'disabledOption' :tempOptionArr[currentOption - 1].OptionId.trim().length === 0}">
                <div class="font-weight-bold cursor-pointer" v-on:click="openFileExplorerWindow($event, tempOptionArr[currentOption - 1].OptionId, currentOption - 1)" :class="{'disabledOption' :tempOptionArr[currentOption - 1].OptionId.trim().length === 0}">
                Choose Image
                </div>
              </div>  
            </div>  
            <div class="row">
              <div class="col-md-12 col-lg-12">
                <!-- <input type="file" id="courseimage" accept=".jpg, .jpeg, .png"> -->
                <input type="file" v-bind:id="'img_' + tempOptionArr[currentOption - 1].OptionId" accept=".jpg, .jpeg, .png" style="display: none;" v-on:change="onFileSelected($event,tempOptionArr[currentOption - 1].OptionId, currentOption - 1)" :disabled="tempOptionArr[currentOption - 1].OptionId.trim().length === 0"/>
              </div>  
            </div>
          </div>  
          <div class="col-md-6 col-lg-6">
            <div class="form-group">
              <!-- <input type="text" class="form-control" v-model="tempOptionArr[currentOption - 1].OptionText" maxlength="1024"> -->
              <textarea class="form-control" rows="2" v-model="tempOptionArr[currentOption - 1].OptionText" maxlength="1024"></textarea>
            </div>
          </div>
          <div class="col-md-1 col-lg-1">
            <span class="glyphicon glyphicon-plus-sign cursor-pointer" @click="addNewOption" v-if="tempOptionArr[currentOption - 1].AllowToAddNextOption"></span>            
          </div>
          <div class="col-md-1 col-lg-1">
            <span class="glyphicon glyphicon-minus-sign cursor-pointer" @click="removeOption($event,currentOption)"></span>
          </div>  
        </div> 
        <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
        <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="resetAllCorrectOption"></confirmation-alert>
  </div>
</template>
<script>
import { elementService } from '@/server-util/element-service'
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
export default {
  props: ['selectedMCQType', 'mcqBtnClicked', 'MCQOptions', 'correctAnswer', 'elementObj'],
  name: 'udpate-mcq-element',
  created () {
    this.addOptionsInTempOptionArr()
    this.setDefaultValues()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      tempOptionArr: [],
      totalOptions: 1,
      alphabetArr: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      mcqType: -1,
      showConfirmationBox: false,
      isMcqImageSelected: false
    }
  },
  components: {
    'confirmation-alert': ConfirmationOverlay,
    'alert-box': AlertBox
  },
  mounted: function () {
    this.setMcqImages()
  },
  methods: {
    setMcqImages: function () {
      for (var i = 0; i < this.getMCQOptionsValue.length; i++) {
        if (this.getMCQOptionsValue[i].ImageUrl !== null && this.getMCQOptionsValue[i].ImageUrl !== undefined && this.getMCQOptionsValue[i].ImageUrl !== '') {
          var optionId = this.getMCQOptionsValue[i].OptionId
          document.getElementById('mcqImg_' + optionId).src = this.getMCQOptionsValue[i].ImageUrl + '?' + Math.random()
        }
      }
    },
    uploadSelectedImg: function (optionId, currSelectedPos) {
      var storeObj = this.$store
      if (
          storeObj.state.access_token !== undefined &&
          storeObj.state.access_token > 0
        ) {
        this.tempOptionArr[currSelectedPos].showSpinner = true
        var fileUrl = document.getElementById('img_' + optionId).files[0]
        const formData = new FormData()
        formData.append('OptionId', optionId)
        formData.append('Image', fileUrl)
        elementService
          .updateMcqOptionImage(storeObj.state.access_token, formData)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              this.tempOptionArr[currSelectedPos].showSpinner = false
            } else {
              document.getElementById('img_' + optionId).value = ''
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // this.showSpinner = false
              this.tempOptionArr[currSelectedPos].showSpinner = false
            }
          }, errorObj => {
            // AK: Hide Spinner
            // this.showSpinner = false
            document.getElementById('img_' + optionId).value = ''
            this.tempOptionArr[currSelectedPos].showSpinner = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Selected Access Token is NULL hence declined Upload MCQ sOPERATION'
        )
      }
    },
    deleteSelectedImg: function (optionId, currSelectedPos) {
      var storeObj = this.$store
      if (
          storeObj.state.access_token !== undefined &&
          storeObj.state.access_token > 0
        ) {
        this.tempOptionArr[currSelectedPos].showSpinner = true
        elementService
          .deleteMcqOptionImage(storeObj.state.access_token, optionId)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              this.tempOptionArr[currSelectedPos].showSpinner = false
            } else {
              document.getElementById('img_' + optionId).src = this.tempOptionArr[currSelectedPos].ImageUrl
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // this.showSpinner = false
              this.tempOptionArr[currSelectedPos].showSpinner = false
            }
          }, errorObj => {
            // AK: Hide Spinner
            // this.showSpinner = false
            document.getElementById('img_' + optionId).src = this.tempOptionArr[currSelectedPos].ImageUrl
            this.tempOptionArr[currSelectedPos].showSpinner = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Selected Access Token is NULL hence declined Upload MCQ sOPERATION'
        )
      }
    },
    openFileExplorerWindow: function (event, optionId, currSelectedPos) {
      document.getElementById('img_' + optionId).click()
    },
    checkMcqImageExtension: function (fileName) {
      var exts = ['.jpg', '.jpeg', '.png']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    },
    onFileSelected: function (event, optionId, currSelectedPos) {
      if (
        !this.checkMcqImageExtension(
          document.getElementById('img_' + optionId).value
        )
      ) {
        this.showAlertDialog = true
        this.errorMsg =
          'Please select .jpg, .jpeg or .png file.'
        event.target.value = ''
        this.updateIsMcqImageSelectedFlag(event, optionId, currSelectedPos, false)
        return
      }
      var i = parseInt(currSelectedPos)
      this.tempOptionArr[i].IsImageSelected = true
      var selectedFile = event.target.files[0]
      var reader = new FileReader()
      var imgtag = document.getElementById('mcqImg_' + optionId)
      this.uploadSelectedImg(optionId, currSelectedPos)
      imgtag.title = selectedFile.name
      reader.onload = function (event) {
        imgtag.src = event.target.result
      }
      reader.readAsDataURL(selectedFile)
    },
    updateIsMcqImageSelectedFlag: function (event, optionId, currSelectedPos, flagToUpdate) {
      var i = parseInt(currSelectedPos)
      this.tempOptionArr[i].IsImageSelected = flagToUpdate
      this.deleteSelectedImg(optionId, i)
    },
    addOptionObjOnInitialLoad: function () {
      // AK: create new optionObj
      var optionObj = {
        OptionId: '',
        OptionNo: this.alphabetArr[this.totalOptions - 1],
        OptionText: '',
        ImageUrl: '',
        IsImageSelected: false,
        showSpinner: false,
        SubOptions: '',
        CorrectSubOption: '',
        IsSelected: false,
        AllowToAddNextOption: true
      }
      // AK: add it to tempOptionArr
      this.tempOptionArr.push(optionObj)
      console.log('this.tempOptionArr >>>> ' + JSON.stringify(this.tempOptionArr))
    },
    addNewOption: function () {
      if (this.tempOptionArr[this.totalOptions - 1].OptionText.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'To add next option, please fill in the "' + this.alphabetArr[this.totalOptions - 1] + '" option text first.'
        return
      }
      if (this.totalOptions !== 26) {
        // AK: Remove allow to add next option from current optionObj
        this.tempOptionArr[this.totalOptions - 1].AllowToAddNextOption = false
        // AK: Added new object
        this.totalOptions += 1
        this.addOptionObjOnInitialLoad()
      } else {
        this.showAlertDialog = true
        this.errorMsg = 'Add option limit exceeded.'
      }
    },
    removeOption: function (event, currentIndex) {
      if (this.totalOptions !== 1) {
        if (currentIndex === this.totalOptions) {
          // AK: IF user removed last option then show Add button previous option
          this.tempOptionArr[currentIndex - 2].AllowToAddNextOption = true
        }
        // AK: Remove given option from Array
        this.udpatedTempArrAfterDelete(currentIndex - 1)
        this.totalOptions -= 1
      } else {
        this.showAlertDialog = true
        this.errorMsg = 'Minimum one option is required.'
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    udpatedTempArrAfterDelete: function (indexToRemove) {
      this.tempOptionArr.splice(indexToRemove, 1)
      // AK: After removing option, re-arrange the OptionNo again
      this.reArrangeOptionNo()
      console.log('After Delete >>> ' + JSON.stringify(this.tempOptionArr))
    },
    reArrangeOptionNo: function () {
      for (var i = 0; i < this.tempOptionArr.length; i++) {
        this.tempOptionArr[i].OptionNo = this.alphabetArr[i]
      }
      console.log('After Re-arranging Option Numbers >>> ' + JSON.stringify(this.tempOptionArr))
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of confrimation overlay
      this.showConfirmationBox = value
    },
    resetAllCorrectOption: function (value) {
      // AK: If user migrate from previous select question type to new, reset all correct option data
      if (value) {
        // AK: Assign new type
        this.mcqType = this.selectedMCQType
        for (var i = 0; i < this.tempOptionArr.length; i++) {
          this.tempOptionArr[i].IsSelected = false
        }
      }
      console.log('After resetAllCorrectOption >>> ' + JSON.stringify(this.tempOptionArr))
    },
    selectedSingleChoiceOption: function (event, currentOption) {
      // AK: Reset all option values except selected
      for (var i = 0; i < this.tempOptionArr.length; i++) {
        if (i === (currentOption - 1)) {
          this.tempOptionArr[i].IsSelected = true
        } else {
          this.tempOptionArr[i].IsSelected = false
        }
      }
      console.log('After selectedSingleChoiceOption >>> ' + JSON.stringify(this.tempOptionArr))
    },
    selectedCorrectAnsCount: function () {
      var totalCorrectAns = 0
      for (var i = 0; i < this.tempOptionArr.length; i++) {
        if (this.tempOptionArr[i].IsSelected) {
          ++totalCorrectAns
        }
      }
      return totalCorrectAns
    },
    setDefaultValues: function () {
      this.totalOptions = this.getMCQOptionsValue.length
      this.mcqType = this.selectedMCQType
    },
    addOptionsInTempOptionArr: function () {
      // AK: Add object in Temp array in with respective Correct Answers
      for (var i = 0; i < this.getMCQOptionsValue.length; i++) {
        var optionObj = {
          OptionId: this.getMCQOptionsValue[i].OptionId,
          OptionNo: this.getMCQOptionsValue[i].OptionNo,
          OptionText: this.getMCQOptionsValue[i].OptionText,
          ImageUrl: this.getMCQOptionsValue[i].ImageUrl,
          showSpinner: false,
          IsImageSelected: this.getMCQOptionsValue[i].ImageUrl !== null && this.getMCQOptionsValue[i].ImageUrl !== undefined && this.getMCQOptionsValue[i].ImageUrl !== '',
          SubOptions: this.getMCQOptionsValue[i].SubOptions,
          CorrectSubOption: this.getMCQOptionsValue[i].CorrectSubOption,
          IsSelected: this.getCorrectAnswers !== null && this.getCorrectAnswers !== 'null' && this.getCorrectAnswers !== '' && this.getCorrectAnswers.indexOf(this.getMCQOptionsValue[i].OptionNo) !== -1,
          AllowToAddNextOption: (i + 1) === this.getMCQOptionsValue.length
        }
        this.tempOptionArr.push(optionObj)
      }
      console.log('Initial tempOptionArr after Adding Options  >>>> ' + JSON.stringify(this.tempOptionArr))
    }
  },
  computed: {
    getSelectedMCQTypeValue: {
      get: function () {
        // AK: First Check user is selected Different Answer than current is yes then reset all correct option values
        if (this.mcqType !== this.selectedMCQType) {
          this.resetAllCorrectOption(true)
        }
        this.mcqType = this.selectedMCQType
        return this.selectedMCQType
      }
    },
    getMCQOptionsValue: {
      get: function () {
        return this.MCQOptions
      }
    },
    getCorrectAnswers: {
      get: function () {
        return this.correctAnswer
      }
    },
    VideoURLValue: {
      get: function () {
        return this.elementObj.MCQItem.ExplanationVideoUrl
      },
      set: function (newValue) {
        this.elementObj.MCQItem.ExplanationVideoUrl = newValue
      }
    },
    HDVideoURLValue: {
      get: function () {
        return this.elementObj.MCQItem.ExplanationHDVideoUrl
      },
      set: function (newValue) {
        this.elementObj.MCQItem.ExplanationHDVideoUrl = newValue
      }
    },
    LowVideoURLValue: {
      get: function () {
        return this.elementObj.MCQItem.ExplanationLowQualityVideoUrl
      },
      set: function (newValue) {
        this.elementObj.MCQItem.ExplanationLowQualityVideoUrl = newValue
      }
    }
  },
  watch: {
    mcqBtnClicked: function () {
      var regex = /^(?:([0-5]?\d):)?([0-5]?\d)$/g
      if (this.elementObj.Title.trim().length === 0) {
        this.errorMsg = 'Title can\'t be empty.'
        this.showAlertDialog = true
        this.$emit('addOptions', false)
      } else if ((this.elementObj.Duration.trim().length !== 0 && this.elementObj.Duration.indexOf(':') === -1)) {
        this.showAlertDialog = true
        this.errorMsg = 'Duration format should be MM:SS.'
        this.$emit('addOptions', false)
      } else if (this.elementObj.IncludeInProgress && this.elementObj.Duration.trim().length > 0 && !regex.test(this.elementObj.Duration)) {
        this.showAlertDialog = true
        this.errorMsg = 'Please enter a valid duration.'
        this.$emit('addOptions', false)
      } else if (this.elementObj.MCQItem.QuestionText.trim().length === 0) {
        this.errorMsg = 'Question text can\'t be empty.'
        this.showAlertDialog = true
        this.$emit('addOptions', false)
      } else if (this.LowVideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.LowVideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.LowVideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid Low Quality Video url.'
        this.$emit('addOptions', false)
      } else if (this.VideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.VideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.VideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid Auto Quality Video url.'
        this.$emit('addOptions', false)
      } else if (this.HDVideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.HDVideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.HDVideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid High Quality Video url.'
        this.$emit('addOptions', false)
      } else {
        // AK: Check weather last option filled or not
        if (this.tempOptionArr[this.totalOptions - 1].OptionText.trim().length === 0) {
          this.showAlertDialog = true
          this.errorMsg = 'Please fill in the \'' + this.alphabetArr[this.totalOptions - 1] + '\' option text'
          if (this.totalOptions !== 1) {
            this.errorMsg += ' or remove it.'
          } else {
            this.errorMsg += '.'
          }
          this.$emit('addOptions', false)
        } else {
          var totalCorrectAnsMarkedCount = this.selectedCorrectAnsCount()
          switch (this.getSelectedMCQTypeValue) {
            case constants.Question_Type.Single_Answer:
              if (totalCorrectAnsMarkedCount > 0) {
                this.$store.state.createMcqOptions = this.tempOptionArr
                this.$emit('addOptions', true)
              } else {
                this.errorMsg = 'Please select at least one correct option to update \'Single Answer\' type MCQ.'
                this.showAlertDialog = true
                this.$emit('addOptions', false)
              }
              break
            case constants.Question_Type.Multiple_Answers:
              // AK: check than one answer selected or not?
              if (totalCorrectAnsMarkedCount > 1) {
                this.$store.state.createMcqOptions = this.tempOptionArr
                this.$emit('addOptions', true)
              } else {
                this.errorMsg = 'Please select more than one correct options to update \'Multiple Answer\' type MCQ.'
                this.showAlertDialog = true
                this.$emit('addOptions', false)
              }
              break
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 5%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}

.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.text-align-left {
  text-align: left !important;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-21px {
  font-size: 21px;
}
.font-size-16px {
  font-size: 16px;
}
.text-align-left {
  text-align: left;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.margin-top-0Point7Perc {
  margin-top: 0.7%;
}
.margin-top-0Point5Perc {
  margin-top: 0.5%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
.padding-right-0px{
  padding-right: 0px !important;
}
.padding-left-0px{
  padding-left: 0px !important;
}
.font-size-12px{
  font-size: 12px;
}
.glyphicon {
    font-size: 25px;
}
.course-image-height {
  height: 50px !important;
}
.choose-course-image-height {
  height: 30px !important;
}
.padding-left-right-0px {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.upload-img-width-height {
  height: 30px;
  width: 30px;
}
.horizontal-center-align {
  margin: 0 auto;
}
.middle {
  transition: 0.5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}

.container:hover .image {
  opacity: 0.3;
}

.container:hover .middle {
  opacity: 1;
}

.text {
  background-color: black;
  color: white;
  font-size: 10px;
  padding: 5px 5px;
  opacity: 0.6;
  border-radius: 5px;
}
.cursor-pointer {
  cursor: pointer;
}
.course-image-box-border {
  border: 1px solid #dddddd !important;
}
.disabledOption {
  opacity: 0.2 !important;
  cursor: default !important;
}
.loader {
  position: absolute;
  left: 60px;
  top: 10px;
  z-index: 1000;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.zoom {
    padding: 0px;
    /* background-color: green; */
    transition: transform .2s;
    width: 100px;
    height: 200px;
    margin: 0 auto;
}
.zoom:hover {
    -ms-transform: scale(1.5); /* IE 9 */
    -webkit-transform: scale(1.5); /* Safari 3-8 */
    transform: scale(1.8); 
    z-index: 1;
}
.border-red{
  border: 1px solid red;
}
.background-color-grey{
  background-color: #F8F8F8;
}
</style>


// WEBPACK FOOTER //
// src/components/UpdateMCQOption.vue